import { makeAutoObservable } from "mobx";
import { ApplicationSettingsModel } from "../models/ApplicationSettingsModel";
import { AccountService } from "../services";

export class ApplicationSettingsStore {
  public applicationSettings: ApplicationSettingsModel =
    new ApplicationSettingsModel();
  public isLoadingInProgress = true;
  constructor() {
    makeAutoObservable(this);
    this.loadSettings();
  }

  public loadSettings = async () => {
    this.isLoadingInProgress = true;
    AccountService.getApplicationSettings().subscribe((response) => {
      if (response.result) {
        this.applicationSettings = ApplicationSettingsModel.deserializeAPIModel(
          response.result
        );
      }
      this.isLoadingInProgress = false;
    });
  };

  isPurchaseDomainAllowed(domain: string): boolean {
    return this.applicationSettings.purchaseDomains.some(
      (d) => d.domain?.toLocaleLowerCase() === domain?.toLocaleLowerCase()
    );
  }
}

export default new ApplicationSettingsStore();
